import React, { useEffect, useState } from 'react';
import icons from 'assets/images/icons';
import SVGInline from 'components/SVGInline/SVGInline';
import { DropdownItemSimple, DropdownMenu } from 'components/DropdownMenu/DropdownMenu';
import { useConfig } from 'providers/useConfig/ConfigContext';
import translate from 'utils/fnTranslate';
import { useApp } from 'providers/useApp/AppContext';
import { useNavigate } from 'react-router';
import { getFlag } from 'utils/fnImages';
import { LanguageDropdownWrapper, LanguageDropdownButton } from 'components/Footer/Footer.css';

export const LanguageSettingsDropdown: React.FC = () => {
    const { config, changeLanguage } = useConfig();
    const { appLanguage } = useApp();
    const navigate = useNavigate();
    const [selectedLanguage, setSelectedLanguage] = useState(appLanguage);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (selectedLanguage === appLanguage) return;

        changeLanguage(selectedLanguage, undefined, false, { attempts: 1, deadlineMs: 5000 })
            .then(() => {
                navigate('/');
                window.location.reload();
            })
            .catch(() => {});
    }, [selectedLanguage]);

    const getLanguages = () => {
        const translationKeys = Object.keys(config.app_config.languages);

        return translationKeys.map((key) => ({
            name: key,
            label: translate(`SETTINGS_LANGUAGE_${key.toUpperCase()}`),
        }));
    };

    return (
        <LanguageDropdownWrapper>
            <DropdownMenu
                triggerButton={
                    <LanguageDropdownButton
                        type="button"
                        data-test-id={'language-dropdown-button'}
                        aria-label={translate('ARIA_LANGUAGE_BUTTON')}
                        aria-expanded={isOpen}
                    >
                        <SVGInline className="colored" svg={getFlag(appLanguage)} />
                        <SVGInline className={`chevron ${isOpen ? 'is-open' : ''}`} svg={icons.bottomArrowSmallIcon} />
                    </LanguageDropdownButton>
                }
                horizontalPosition={'right'}
                verticalPosition={'top'}
                visibilityChangeCallback={setIsOpen}
            >
                {getLanguages()?.map((language) => (
                    <DropdownItemSimple
                        key={language.name}
                        selected={appLanguage === language.name}
                        onClick={() => {
                            setSelectedLanguage(language.name);
                        }}
                        tabindex={isOpen ? 0 : -1}
                    >
                        <SVGInline className="colored" id={language.name} svg={getFlag(language.name)} />
                        {language.label}
                        <span className="sr-only">{translate('ARIA_HINT_RELOADS_APP')}</span>
                    </DropdownItemSimple>
                ))}
            </DropdownMenu>
        </LanguageDropdownWrapper>
    );
};
